import { Injectable } from '@angular/core';
import { SuperHttpClientProvider } from '@app/core/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface AemetStation {
  idema: string;
  name: string;
  province: string;
  municipality?: string | null;
  altitude?: number | null;
  lat: number;
  lon: number;
}

@Injectable({
  providedIn: 'root'
})
export class AemetStationsService {
  constructor(private $http: SuperHttpClientProvider) {}

  getProvinces(): Observable<string[]> {
    return this.$http.default
      .get('/admin/aemet/provinces')
      .pipe(map((response: any) => response?.provinces || []));
  }

  getStationsByProvince(province: string): Observable<AemetStation[]> {
    return this.$http.default
      .get('/admin/aemet/stations', { params: { province } })
      .pipe(map((response: any) => response?.stations || []));
  }
}
